import React from 'react';
import './PageWrapper.module.scss';

// Import components
import Header from './Header/Header';
import FilterMenu from './FilterMenu/FilterMenu';

type Props = {
  children: React.ReactNode;
  filterMenu?: boolean;
  background?: string;
  article?: boolean;
};

export default function PageWrapper({
  children,
  filterMenu,
  background,
  article,
}: Props) {
  return (
    <div
      style={background ? { background } : {}}
      styleName={`page-wrapper ${article ? 'article ' : ''} ${
        background ? 'background' : ''
      } ${filterMenu ? 'filter-menu' : ''}`}
    >
      <div styleName="background-image" />
      <Header filterMenu={filterMenu} />
      {filterMenu && <FilterMenu />}
      <div styleName="content">
        {/* <img styleName="texture" alt="paper" src="/images/grain.jpg" /> */}
        <div styleName="inner">{children}</div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
